// extracted by mini-css-extract-plugin
export default {"drawerNavCard":"EB2_BMxL"};